import React from "react";
import "./admin.css";
import { Routes, Route } from "react-router-dom";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function AdminDashboard() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
export default AdminDashboard;
